import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";

// Styled component to make the dialog background transparent gray
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // transparent gray
  },
}));

type genericDialogPropsType = {
  open: boolean;
  title: string;
  content: React.ReactNode;
  onClose: () => void;
  onOk?: () => void;
  onCancel: () => void;
  okButtonName?: string;
  handleSubmit?: (payload: any) => any;
};

export default function GenericModal(
  genericDialogProps: genericDialogPropsType
) {
  const {
    open,
    title,
    content,
    onClose,
    onOk,
    onCancel,
    okButtonName,
    handleSubmit
  } = genericDialogProps;

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit ? handleSubmit : onOk } color="primary" autoFocus>
          {okButtonName ? okButtonName : "OK"}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
